import { CMS_SCRIPT_LOADED, SHOPPING_LINKS_LOADED } from '../actionTypes';

export default function contactRepUrl(state, action) {
  switch (action.type) {
    case CMS_SCRIPT_LOADED:
    case SHOPPING_LINKS_LOADED:
      return action.payload['contact.rep'];
    default:
      return state || false;
  }
}
